/<template>
    <aside id="rpanel" class="as-sidebar as-sidebar--right" style="text-align: left">
        <div class="as-container as-container--border">
        <section>
            <Legend />
          </section>
        </div>
        <div class="as-container as-container--border">
        <section>
          <DemographicViewer />
        </section>
        </div>
      </aside>
</template>
<script>
import Legend from './Legend'
import DemographicViewer from './DemographicViewer'

export default {
  name: 'RightPanel',
  components: {
    Legend,
    DemographicViewer
  }
}
</script>

<style>
#rpanel {
  color: white !important;
  background-color: #20202C;
}
as-histogram-widget {
  --as--histogram-widget--color: white !important;
  --as--histogram-widget--figure--text-color: white;
  --as--histogram-widget--label-color: white;
  --as--histogram-widget--background-color: #20202C; 
}
as-category-widget {
  --as--category-widget--background-color: #20202C;
  --as--category-widget--color: #white;
}
as-widget-header {
    --as--widget-header__header--color: white;
    --as--widget-subheader--color: white;
}
as-histogram-widget .figure .y-axis {
    --widget-axis-text-color: white;
    --widget-axis-line-color: #FEC503;
}
.as-color--type-01{
  color: #47DB99;
}

.as-sidebar {
width: 360px !important;
}

as-legend-color-continuous-polygon .as-legend-color-continuous-polygon--label {
    font-size: small;
    color: white;
}
</style>
